export const APP_CONFIG = {
  MAX_FILE_SIZE: 100 * 1024 * 1024 * 1024, // 100GB
  ALLOWED_FILE_TYPES: ['.mp4', '.mkv'],
  ALLOWED_MIME_TYPES: ['video/mp4', 'video/x-matroska'],
  
  RETENTION_PERIODS: {
    default: 365, // 1 year in days
    premium: 730, // 2 years in days
  },
  
  LONG_TERM_THRESHOLD_DAYS: 30,
  SYNC_INTERVAL_HOURS: 3,
  
  PREVIEW_DURATION_SECONDS: 10,
  PREVIEW_MAX_WIDTH: 480,
  
  JWT_EXPIRY_HOURS: 24,
  SESSION_EXPIRY_HOURS: 168, // 1 week
  
  PAGINATION: {
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
  },
} as const;

export const TWITCH_CONFIG = {
  OAUTH_URL: 'https://id.twitch.tv/oauth2/authorize',
  TOKEN_URL: 'https://id.twitch.tv/oauth2/token',
  API_BASE_URL: 'https://api.twitch.tv/helix',
  SCOPES: [
    'user:read:email',
    'channel:read:stream_key',
  ],
} as const;

export const R2_PATHS = {
  VIDEOS: 'users/{userId}/videos',
  PREVIEWS: 'users/{userId}/previews',
  THUMBNAILS: 'users/{userId}/thumbnails',
} as const;

export const KV_KEYS = {
  USER_SESSION: 'session:{userId}',
  USER_PROFILE: 'user:{userId}',
  VOD_METADATA: 'vod:{vodId}',
  USER_STATS: 'stats:{userId}',
  SYNC_LOCK: 'sync:lock:{userId}',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  PAYLOAD_TOO_LARGE: 413,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

export const ERROR_CODES = {
  INVALID_TOKEN: 'INVALID_TOKEN',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT_PERMISSIONS',
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  VOD_NOT_FOUND: 'VOD_NOT_FOUND',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
  SYNC_IN_PROGRESS: 'SYNC_IN_PROGRESS',
  RATE_LIMITED: 'RATE_LIMITED',
} as const;